module.exports = __webpack_public_path__ + "img/Lefkada.40204797.png";